// extracted by mini-css-extract-plugin
export default {"selectionBox":"style_selectionBox__oDBwx","selectionTitle":"style_selectionTitle__D1SYh","chevronIcon":"style_chevronIcon__FzUW-","boxWithData":"style_boxWithData__E4ZrV"};